import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { MOCKUP_URL } from '../../data/images';
const steps = ['Open', 'Choose', 'Teach'];
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-159" data-mp="1jp64btsvgu3a">
      <div className="mx-auto max-w-5xl" data-id="element-160" data-mp="1ogo5oiyt4wos">
        <SectionHeading id="solution-heading" eyebrow="Meet Your New Teaching System" title={<>
              Everything You Need to Teach Hairdressing — <Accent data-id="element-162" data-mp="1yd0zrhy9lck2">In One Place.</Accent>
            </>} body="Hair Instructor Ready™ organizes professional hair education into one structured system designed specifically for educators." data-id="element-161" data-mp="1ohpj2u3apv9o" />

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] font-semibold leading-relaxed text-brand-charcoal sm:text-[16px]" data-id="element-163" data-mp="27d64fkc2pwuj">
          Open the system. Choose what you need. Prepare your class. Start teaching.
        </p>

        <ol className="mx-auto mt-10 flex max-w-lg items-center justify-center gap-3 sm:gap-5" role="list" data-id="element-164" data-mp="mykimbd8dkr">
          {steps.map((step, index) => <li key={step} className="flex items-center gap-3 sm:gap-5" data-id="element-165" data-mp="3rzt7kqewfx7v" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="font-display text-[1.6rem] text-brand-gold" data-id="element-166" data-mp="3n2b074gj5q1z">
                  →
                </span>}
              <span className="rounded-full border border-brand-gold/40 bg-white px-5 py-2.5 font-body text-[13px] font-bold uppercase tracking-[0.16em] text-brand-charcoal sm:text-[14px]" data-id="element-167" data-mp="jlkoc8y9oisd">
                {step}
              </span>
            </li>)}
        </ol>

        <img src={MOCKUP_URL} alt="The complete Hair Instructor Ready system" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block w-full max-w-[560px] object-contain lg:max-w-[780px]" style={{
        filter: 'drop-shadow(0 30px 36px rgba(120, 96, 56, 0.22))'
      }} data-id="element-168" data-mp="4oad90pjdex6" />
      </div>
    </section>;
}